import createInlineButtons from './inline-buttons.js';
import createInsertButtons from './insert-buttons.js';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-editor-common';
import './ModalCustomStyles.js';
import './VerticalEmbedInputModal.js';
import 'prop-types';
import 'react';
import './VerticalEmbedInsertModal.js';
import 'wix-rich-content-ui-components';
import '../constants.js';
import 'ricos-schema';
import '../ItemsList-2febaa8a.js';
import '../style-inject.es-746bb8ed.js';
import 'classnames';
import './itemsList/Item.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../convertDuration.js';
import 'lodash';
import '../types.js';
import 'wix-rich-content-common';
import '../icons/ReplaceIcon.js';
import '../icons/Product.js';
import '../icons/Event.js';
import '../icons/Booking.js';

const createToolbar = ({
  settings,
  t,
  isMobile,
  locale,
  experiments
}) => {
  return {
    InlineButtons: createInlineButtons({ t, isMobile, settings, locale, experiments }),
    InsertButtons: createInsertButtons({ t, settings, isMobile, locale, experiments }),
    name: "vertical-embed"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
